import styled from 'styled-components';

export const EmptyPageWrapper = styled.div `
  padding-top: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const EmptyPageImageWrapper = styled.div`
  background-image: url(${(props) => props.theme.backgroundImage});
  width: 481px;
  height: 392px;
  background-size: cover;
`;

export const MessageTitle = styled.span`
  margin-top: -19px;
  font-size: 32px;
  color: ${(props) => props.theme.titleTextColor};
`;

export const MessageBody = styled.span`
  font-size: 18px;
  color: ${(props) => props.theme.messageTextColor};
  text-align: center;
  margin-bottom: 15px;
  max-width: 480px;
`;

export const EmptyPageFooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  width: 305px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 131px;
  ${'button'} {
    background-color: #0073CA;
    border-color: #0073CA;
  }
`;
